import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/(app)/chain/page.jsx");
